// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__6YYc4","notes":"Notes_notes__1cB0Z","note":"Notes_note__35-rr","markdown":"Notes_markdown__MQTTo"};